// extracted by mini-css-extract-plugin
export var body = "_jz-0";
export var sectionHeader = "_jz-4";
export var shortcutColumns = "_jz-2";
export var shortcutList = "_jz-1";
export var shortcutSection = "_jz-3";